import { createActionName } from "redux/utility"

export const reducerName = "userInvites"

export const USER_INVITES = createActionName(reducerName, "USER_INVITES")
export const USER_INVITE = createActionName(reducerName, "USER_INVITE")
